import React, { useState, useRef, useEffect, useContext } from "react";
import propTypes from "prop-types";
import md5 from "crypto-js/md5";
import cssStyles from "styles/form_group.module.scss";
import { Button, Switch, Icon } from "components";
import PageScrollContext from "context/PageScrollContext";
import classNames from "lib/classNames";

const FormGroup = ({
	label,
	children,
	className = "",
	onFocus,
	onBlur,
	info,
	minWidth = 410,
	focusCondition = () => false,
	styles = { content: {}, title: {} },
	noBorderBottom
}) => {
	const group = useRef(null);
	const { scrollTop, getScrollTop } = useContext(PageScrollContext) || {};

	const handleClick = (container) => (event) => {
		const focusWithIn =
			container === document.activeElement ||
			container.contains(document.activeElement) ||
			focusCondition({ activeElement: document.activeElement, event, container }) ||
			!![...container.querySelectorAll(".sketch-picker")].find((picker) => picker.contains(event.target));
		if (focusWithIn && onFocus) onFocus();
		else if (!focusWithIn && onBlur) onBlur();
	};

	useEffect(() => {
		if (onFocus || onBlur) {
			document.addEventListener("mouseup", handleClick(group.current));
		}
		return () => {
			document.removeEventListener("mouseup", handleClick(group.current));
		};
	}, [group.current]);

	return (
		<div
			className={classNames(
				"flex flex-wrap sm:flex-col md:flex-col lg:flex-row py-6 border-gray-300 group-wrapper",
				{ "border-b": !noBorderBottom }
			)}
		>
			<div
				className={classNames(
					"w-1/3 sm:w-full md:w-full lg:w-1/3 flex-grow group-left-side flex flex-col sm:mb-2 md:mb-2 pr-2"
				)}
				style={{ ...styles.title }}
			>
				<label
					className={classNames(
						"text-lg text-gray-800 mb-2 font-bold capitalize relative group-label cursor-pointer"
					)}
					onClick={(e) => {
						if (!scrollTop) return;
						const padding = 1.5 * parseFloat(getComputedStyle(document.documentElement).fontSize);
						scrollTop(e.target.closest(".mu-group-wrapper").offsetTop - 0);
					}}
					id={`id_${md5(label)}`}
				>
					<Icon
						icon="hashtag"
						style={{
							maxHeight: 27
						}}
						className="absolute top-0 left-0 transform -translate-x-full text-gray-500 h-full pr-1 group-label-icon hidden"
					/>
					{label}
				</label>
				{!!info && (
					<p
						className={classNames("text-gray-500 text-xs italic")}
						dangerouslySetInnerHTML={{
							__html: info.replace("\n", "<br/>")
						}}
					/>
				)}
			</div>

			<div
				className={classNames(
					"sm:w-full md:w-full lg:w-2/3 w-2/3 flex-grow min-w-2/3 flex-shrink-0 pl-2 sm:pl-0 md:pl-0"
				)}
				ref={group}
				style={{
					...styles.content,
					minWidth
				}}
			>
				{children}
			</div>
		</div>
	);
};

FormGroup.propTypes = {
	// children: propTypes.Children.isRequired,
	label: propTypes.string
};
export default FormGroup;
